import Navbar from "../../../components/Navbar/Navbar";
import AccessOverridesList from "../components/AccessOverridesList/AccessOverridesList";

export default function NoteAccessOverrides() {
    return (
        <>
            <Navbar
                title="Note Access Overrides"
                titleTooltip="Providers on this list can write regular session notes for clients whose sessions are paused or inactive. Everyone else can only write termination and pause notification notes for those sessions."
            />
            <div className="page">
                <AccessOverridesList />
            </div>
        </>
    );
}
